import 'modern-normalize/modern-normalize.css';

// eslint-disable-next-line import/no-default-export
export default function Home(): JSX.Element {
  return <>Hello world</>;
}
